<template>
  <div class="editor-container">
    <div class="main-editor">
      <textarea v-model="mainContent" class="main-text-editor" placeholder="تشخیص و توضیحات را وارد نمایید..."
        rows="5"></textarea>
    </div>

    <div class="saved-texts-title">
      <span>متن های ذخیره</span>
      <font-awesome-icon :icon="['fas', 'chevron-down']" class="arrow-icon" />
    </div>

    <div class="input-row">
      <input type="text" v-model="titleContent" class="title-input" placeholder="عنوان را وارد کنید..." />
      <textarea v-model="textContent" class="text-editor" placeholder="توضیحات خود را وارد کنید..."></textarea>
      <div class="button-row">
        <BaseButton title="ذخیره" variant="primary" @click="saveContent" />
        <BaseButton title="انتخاب" variant="success" @click="selectContent" />
        <BaseButton title="انصراف" variant="cancel" @click="closeModal" />
      </div>
    </div>

    <div class="table-container">
      <table class="content-table">
        <thead>
          <tr>
            <th>عنوان</th>
            <th>توضیحات</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in contentList" :key="index">
            <td>{{ item.title }}</td>
            <td>{{ item.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from 'vue'

const props = defineProps({
  recordId: {
    type: [String, Number],
    required: true
  },
  mainContent: {
    type: [String, Number],
    required: true
  },
  isOpen: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['close', 'save', 'select'])
// eslint-disable-next-line no-undef
defineExpose({ confirm });
const mainContent = ref('')
const textContent = ref('')
const titleContent = ref('')
const contentList = ref([])

function closeModal() {
  emit('close')
}
function saveContent() {

}
function confirm() {
  return {
    id: props.recordId,
    description: mainContent.value
  };
}

function selectContent() {
  emit('select', { title: titleContent.value, content: textContent.value })
  closeModal()
}
onMounted(() => {
  mainContent.value = props.mainContent;
})
import BaseButton from '@/components/UiCompunents/BaseButton.vue'

</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.editor-container {
  flex-grow: 1;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-editor {
  width: 100%;
}

.main-text-editor {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  resize: vertical;
  direction: rtl;
  min-height: 100px;
}

.main-text-editor:focus {
  outline: none;
  border-color: #1474f2;
}

.input-row {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 34px;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
}

.title-input {
  width: 33.33%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  direction: rtl;
  height: 100%;
  resize: none;
}

@media screen and (max-width: 768px) {
  .title-input {
    width: 100%;
  }
}

.title-input:focus {
  outline: none;
  border-color: #1474f2;
}

.text-editor-container {
  width: 66.67%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.text-editor {
  width: 33.33%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  resize: none;
  direction: rtl;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  line-height: normal;
}

@media screen and (max-width: 768px) {
  .text-editor {
    width: 100%;
  }
}

.button-row {
  width: 33.33%;
  display: flex;
  justify-content: center;
  gap: 10px;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .button-row {
    width: 100%;
    order: -1;
  }
}

.button-row button {
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.saved-texts-title {
  color: #1474f2;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: flex-end;
}

.arrow-icon {
  color: #1474f2;
  font-size: 12px;
}

.table-container {
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.content-table {
  width: 100%;
  border-collapse: collapse;
  direction: rtl;
}

.content-table th,
.content-table td {
  padding: 8px 12px;
  text-align: right;
  border-bottom: 1px solid #ddd;
}

.content-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.content-table th:first-child,
.content-table td:first-child {
  width: 33.33%;
}

.content-table th:last-child,
.content-table td:last-child {
  width: 66.67%;
}

.content-table tbody tr:hover {
  background-color: #f9f9f9;
}

.save-btn,
.select-btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.save-btn {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
  border: none;
}

.select-btn {
  background-color: var(--background-color-success);
  color: var(--text-color-forthly);
  border: none;
}

</style>